<template>
  <section class="q-pa-md">
    <h1>Airports</h1>
  </section>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import GroupCard from 'pages/_locale/group/GroupCard'

  const moduleName = 'group'
  const { mapActions, mapState } = createNamespacedHelpers(
    moduleName,
  )

  export default {
    components: {
      GroupCard,
    },
    computed: {
      ...mapState(
        [
          'data',
          'meta',
        ],
      ),
    },
    meta: {
      title: 'Groups',
    },
    methods: {
      ...mapActions(
        [
          'index',
        ],
      ),
      async search () {
        return await this.index(
          this.meta,
        )
      },
    },
    data () {
      return {
        moduleName,
      }
    },
    mounted () {
      this.search()
    },
  }
</script>
